// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calculateRow_title__NXOjF {
  opacity: 0.6;
  text-transform: uppercase;
}

.calculateRow_container__Y-ibn {
  display: flex;
}

.calculateRow_container__content__FUkKS {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.3rem;
  width: 10em;
}

.calculateRow_container__title__Sm4CH {
  padding-left: 0.5rem;
  font-size: 0.9rem;
}

.calculateRow_content__1Q8Mx {
  display: flex;
  flex-direction: row;
}

.calculateRow_units__zB8Df {
  padding-top: 0.5rem;
  padding-left: 0.3rem;
}

/* total */
.calculateRow_total__container__ZVNF4 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-right: 3rem;
}

.calculateRow_total__title__Fac\\+u {
  padding-right: 3rem;
  font-weight: bold;
}

.calculateRow_total__price__5AE9- {
  margin-bottom: 0;
}

.calculateRow_total__price_pcs__P86ye {
  font-size: 0.7rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/order_management/orderedit_components/Calculator/css/calculateRow.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".title {\n  opacity: 0.6;\n  text-transform: uppercase;\n}\n\n.container {\n  display: flex;\n}\n\n.container__content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 0.3rem;\n  width: 10em;\n}\n\n.container__title {\n  padding-left: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n}\n\n.units {\n  padding-top: 0.5rem;\n  padding-left: 0.3rem;\n}\n\n/* total */\n.total__container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  padding-right: 3rem;\n}\n\n.total__title {\n  padding-right: 3rem;\n  font-weight: bold;\n}\n\n.total__price {\n  margin-bottom: 0;\n}\n\n.total__price_pcs {\n  font-size: 0.7rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `calculateRow_title__NXOjF`,
	"container": `calculateRow_container__Y-ibn`,
	"container__content": `calculateRow_container__content__FUkKS`,
	"container__title": `calculateRow_container__title__Sm4CH`,
	"content": `calculateRow_content__1Q8Mx`,
	"units": `calculateRow_units__zB8Df`,
	"total__container": `calculateRow_total__container__ZVNF4`,
	"total__title": `calculateRow_total__title__Fac+u`,
	"total__price": `calculateRow_total__price__5AE9-`,
	"total__price_pcs": `calculateRow_total__price_pcs__P86ye`
};
export default ___CSS_LOADER_EXPORT___;
